import styled from 'styled-components';
import {
  Modal as SemanticModal,
  Rating as SemanticRating,
  Form as SemanticForm,
  Checkbox as SemanticCheckbox,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Header as HeaderLayout,
  Text as TextLayout,
  TextAreaFormField,
} from '@playbookux/playbook-web-core';

const SaveButton = styled(ButtonLayoutComponent)`
  min-width: 100px;
`;

const CancelButton = styled(ButtonLayoutComponent.Inverted)`
  min-width: 100px;
`;

const HeaderText = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
`;

const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Modal = styled(SemanticModal)``;

const Content = styled(SemanticModal.Content)`
  &&& {
    display: flex;
    flex-direction: column;
    padding: 30px;
  }
`;

const ContainerButtons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 30px 30px 30px;
`;

const ContainerError = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

const Header = styled(HeaderLayout)``;

const RatingVideo = styled(SemanticRating)`
  margin-bottom: 20px;
`;

const MultiLine = styled(TextAreaFormField).attrs({
  height: '88px;',
})``;

const Form = styled(SemanticForm)``;

const ContainerMultiLine = styled.div``;

const TextPrimay = styled(TextLayout)`
  && {
    margin-bottom: 10px;
  }
`;

const Checkbox = styled(SemanticCheckbox)`
  margin-top: 10px;
`;

export {
  SaveButton,
  ContainerText,
  Modal,
  Content,
  HeaderText,
  ContainerButtons,
  ContainerError,
  Header,
  RatingVideo,
  Form,
  ContainerMultiLine,
  MultiLine,
  TextPrimay,
  Checkbox,
  CancelButton,
};
